const MAX_FILE_SIZE = 104857600; // 100MB in bytes (applies to all file types)

const IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
];

const VIDEO_MIME_TYPES = [
  "video/mp4",
  "video/quicktime",
  "video/webm",
  "video/x-msvideo",
];

const DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "text/plain",
];

const ALLOWED_MIME_TYPES = [
  ...IMAGE_MIME_TYPES,
  ...VIDEO_MIME_TYPES,
  ...DOCUMENT_MIME_TYPES,
];

const ALLOWED_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "webp",
  "heic",
  "heif",
  "mp4",
  "mov",
  "webm",
  "avi",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "csv",
  "txt",
]);

const getExtension = (filename = "") => {
  const parts = filename.toLowerCase().split(".");
  return parts.length > 1 ? parts.pop() : "";
};

export const validateFileSize = (file) => {
  if (file.size > MAX_FILE_SIZE) {
    const sizeMB = (file.size / 1048576).toFixed(2);
    return {
      valid: false,
      error: `File "${file.name}" is too large (${sizeMB}MB). Maximum size is 100MB.`,
    };
  }
  return { valid: true, error: null };
};

export const validateFileType = (file) => {
  const extension = getExtension(file.name);
  const mimeAllowed = ALLOWED_MIME_TYPES.includes(file.type);
  const extensionAllowed = ALLOWED_EXTENSIONS.has(extension);

  if (!mimeAllowed && !extensionAllowed) {
    return {
      valid: false,
      error: `File "${file.name}" has unsupported type. Allowed: Images (JPEG, PNG, WebP, HEIC), Videos (MP4, MOV, WEBM, AVI), Documents (PDF, DOC, DOCX, XLS, XLSX, CSV, TXT).`,
    };
  }
  return { valid: true, error: null };
};

export const validateFile = (file) => {
  const sizeValidation = validateFileSize(file);
  if (!sizeValidation.valid) {
    return sizeValidation;
  }

  const typeValidation = validateFileType(file);
  if (!typeValidation.valid) {
    return typeValidation;
  }

  return { valid: true, error: null };
};

export const validateFiles = (files) => {
  const validFiles = [];
  const invalidFiles = [];

  Array.from(files).forEach((file) => {
    const validation = validateFile(file);
    if (validation.valid) {
      validFiles.push(file);
    } else {
      invalidFiles.push({ file, error: validation.error });
    }
  });

  return { validFiles, invalidFiles };
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
